const template = `
	<span>
		<template v-if="val">{{ val }}</template>
		<slot v-else></slot>
	</span>
`;

export default {
	template,
	props: ['val']
};